document.addEventListener('DOMContentLoaded', () => {
  const features = document.querySelector('.grid-caracteristiques')
  const showMore = document.querySelector('.link-view-more')
  if (features) {
    showMore.addEventListener('click', () => {
      features.classList.toggle('is-open')
      if (features.classList.contains('is-open')) {
        showMore.innerHTML = '<i class="fal fa-arrow-up"></i> Fermer'
      } else {
        showMore.innerHTML = 'Voir plus <i class="fal fa-arrow-down"></i>'
      }
    })
  }

})